import { createSelector } from '@ngrx/store';

import { getUIState } from '../../../site-detail/store/reducers/ui';

export const getUISiteMaxCount = createSelector(getUIState, ({ sitesList }) => sitesList.maxCount);
